import type { ReferredVolumeDay } from "@decibeltrade/sdk";

import { fillDailyWindow } from "../daily-window";

/** One day column of the referred-volume chart, oldest first. */
export interface ReferredVolumeBar {
  dayStartUnixMs: number;
  /** Both-sides USD notional. */
  volumeUsd: number;
  /** Referred subaccounts that traded that day. */
  activeReferrals: number;
}

/**
 * Referred-volume chart columns. Ordering, gap filling and window padding all live in
 * [`fillDailyWindow`]; this only maps a day to its figures.
 *
 * Plots `volume_usd`, which sums taker and maker. The response also carries the split,
 * but a per-entity total must never be taker-only or a maker-heavy referral reads as
 * near-zero.
 */
export function toReferredVolumeBars(
  days: readonly ReferredVolumeDay[],
  windowDays: number,
): ReferredVolumeBar[] {
  return fillDailyWindow(days, windowDays, (dayStartUnixMs, present) => ({
    dayStartUnixMs,
    volumeUsd: present?.volume_usd ?? 0,
    activeReferrals: present?.active_referrals ?? 0,
  }));
}
